import React from "react";
import styles from "./Backdrop.module.css";

const Backdrop = (props) => {
	let zIndexed = null;
	if (props.zIndex) {
		zIndexed = {
			zIndex: props.zIndex,
		};
	}
	return props.show ? (
		<div
			aria-hidden="true"
			onClick={props.clicked}
			className={styles.main}
			style={zIndexed}
		/>
	) : null;
};

export default Backdrop;
